// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"83":"pledge","473":"trade","826":"index"}[chunkId] || chunkId) + "." + {"83":"3330f5d7","471":"134c00d3","473":"77d38e2b","735":"7d4483b4","744":"415f6e74","787":"98ecb56e","826":"3714c7c7"}[chunkId] + ".chunk.js";
};